import { FC } from 'react'
import Image from 'next/image'

import { STATIC_URL } from 'constants/data'

import styles from './write-us-btn.module.scss'

type WriteUsBtnProps = {
  isMobile?: boolean
  handler: () => void
}

const imgPath = {
  mail: `${STATIC_URL}/write-us/icon_mail.svg`,
}
const WriteUsBtn: FC<WriteUsBtnProps> = ({ isMobile, handler }) => {
  return (
    <div className={styles.instruction} onClick={handler}>
      {!isMobile && <div className={styles.hint}>Напишите нам</div>}
      <Image src={imgPath.mail} width={20} height={15} alt="Инонка письма" />
    </div>
  )
}

export default WriteUsBtn
